import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GenericProcessingComponent } from 'src/app/core/dialog/generic-processing/generic-processing.component';
import {
  GridSelectionMode,
  IgxColumnComponent,
  IgxDropDownModule,
  IgxExcelExporterService,
  IgxGridModule,
  IRowSelectionEventArgs,
} from '@infragistics/igniteui-angular';
import { IgxGridComponent, IgxTabsModule } from '@infragistics/igniteui-angular';
import { CommonModule, DatePipe, JsonPipe, NgFor, NgIf } from '@angular/common';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule } from '@angular/forms';
import {
  ICompaniesShortList,
  ICompanySearchCriteria,
  IImportDialogErrors,
  ILotRateList,
  IMarketCompanyRatesByLotNumberWithCompanyId,
  IParkerImportErrors,
  IParkerProfileForParkerTable,
  IParkerProfileImportResult,
  IParkerProfileQueuedForImport,
  IRatesByCompany,
  IState,
} from 'src/app/shared/interfaces';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { ParkerImportPrep } from 'src/app/shared/helpers/profiles/parker-import-prep';
import { ParkerImportValidation } from 'src/app/shared/helpers/profiles/parker-import-validation';
import { AceStates } from 'src/app/shared/data/states';
import { first } from 'rxjs';
import { IgxActionStripModule, IgxGridActionButtonComponent, IgxSelectModule } from '@infragistics/igniteui-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { PasteHandlerStandalone } from 'src/app/shared/directives/past-handler-standalone-directive';
import { IgxEditRow } from '@infragistics/igniteui-angular/lib/grids/common/crud.service';
import { DialogParkerImportErrorsComponent } from '../parker-v2-dialogs/dialog-parker-import-errors/dialog-parker-import-errors.component';

@Component({
  selector: 'app-parkers-v2-import',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    MatTooltipModule,
    MatTabsModule,
    MatIconModule,
    JsonPipe,
    MatSnackBarModule,
    FormsModule,
    IgxGridModule,
    IgxTabsModule,
    IgxGridComponent,
    NgFor,
    NgIf,
    IgxSelectModule,
    IgxActionStripModule,
    MatButtonModule,
    PasteHandlerStandalone,
    IgxDropDownModule,
  ],
  templateUrl: './parkers-v2-import.component.html',
  styleUrl: './parkers-v2-import.component.scss',
})
export default class ParkersV2ImportComponent implements OnInit, OnDestroy {
  @ViewChild('gridProfile', { read: IgxGridComponent, static: true })
  public gridProfile: IgxGridComponent;
  @ViewChild('gridProfileResults', { read: IgxGridComponent, static: true })
  public grid2: IgxGridComponent;
  parkerProfilesReviewed: IParkerProfileQueuedForImport[] = [];
  numberOfParkers: number = 0;
  public validationMode: boolean = false;
  companyRateList: IRatesByCompany[];
  rateList: number[];
  currentRowIndex: number = 0;
  ignoreDirective: boolean = false;
  errList: string = 'Last Name, Rate';
  profileData: IParkerProfileQueuedForImport[] = [];
  filteredData: IParkerProfileQueuedForImport[];
  companyList: ICompaniesShortList[] = [];
  marketRateList: ILotRateList[] = [];
  stateList: IState[] = [];
  currentLotNumber: string = '';
  showParkerStatusColumn: boolean = true;
  enablePasteMode: boolean = false;
  validationErrors: IParkerImportErrors[] = [];
  suppressErrors: boolean = false;
  parkerImportResults: IParkerProfileImportResult[] = [];
  importGridEditable: boolean = true;
  importResultsGridReadOnly: boolean = false;
  profileValidationCompleted: boolean = false;
  importErrorsExist: boolean = false;
  parkerSuccessResults: IParkerProfileImportResult[] = [];
  marketCompanyRatesForLotNumber: IMarketCompanyRatesByLotNumberWithCompanyId[] = [];
  parkerImportErrors: number = 0;
  validationCheckCompleted: boolean = false;
  isValidating: boolean = false;
  isImporting: boolean = false;
  numberOfParkersValidated: number = 0;
  importInProgress: boolean = false;
  errorId: number = -1;
  selectionMode: GridSelectionMode = 'single';

  constructor(
    private excelExportService: IgxExcelExporterService,
    private dataService: DataService,
    private parkerStateService: ParkerStateService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router,
    private datePipe: DatePipe,
    private _matDialog: MatDialog,
    private _appGeneralState: AppGeneralStateService,
  ) {
    this._appGeneralState.canChangeLot = false;
    this.currentLotNumber = this._appGeneralState.currentLotNumber;
    this.initStateList();
    this.GetActiveAndInActiveCompanyListForLotNumber(this.currentLotNumber);
    //this.CreateGridSampleProfileData();
  }
  ngOnDestroy(): void {
    this._appGeneralState.canChangeLot = true;
  }

  public onColumnInit(col: IgxColumnComponent) {
    col.cellClasses = this.backgroundClasses;
  }

  public backgroundClasses = {
    highlighted: (rowData: any, columnKey: any) => {
      // return rowData.rowNumber === this.errorId;
      const isError = this.isRowError(rowData.rowNumber);
      return isError;
    },
  };

  isRowError(rowNumber: number): boolean {
    let ii: number;
    let errorStatus: boolean = false;

    if (this.suppressErrors) return false;

    for (ii = 0; ii < this.validationErrors.length; ii++) {
      if (this.validationErrors[ii].rowNumber + 1 == rowNumber) {
        errorStatus = true;
        break;
      }
    }

    return errorStatus;
  }

  ngOnInit(): void {}

  public handleRowSelection(event: IRowSelectionEventArgs) {
    // use event.newSelection to retrieve primary key/row data of latest selected row
    //this.selectedRowsCount = event.newSelection.length;
    const selectedRowIndex = event.newSelection[0];
    this.showErrorDialog(selectedRowIndex.rowNumber);
  }

  LogProfileDataArray(): void {
    let newParkerId: string = '';
    let currentDate: Date = this.profileData[0].endDate;
    let month: number = +currentDate.getMonth().toString();
    let day: number = +currentDate.getDate().toString();
    let year: number = +currentDate.getFullYear().toString();
    let formattedEndDate: Date = new Date(year, month, day, 0, 0, 0);

    currentDate = new Date(this.profileData[0].startDate);
    month = +currentDate.getMonth().toString();
    day = +currentDate.getDate().toString();
    year = +currentDate.getFullYear().toString();
    let formattedStartDate: Date = new Date(year, month, day, 0, 0, 0);

    try {
      let newDate = new Date(this.profileData[0].startDate);
      // if(newDate.toLocaleDateString() == 'Invalid Date'){

      // }
    } catch (err) {}
  }

  GetProfileDataForValidation(): IParkerProfileQueuedForImport[] {
    let ii: number = 0;
    let rowError: boolean = false;
    let dataToValidate: IParkerProfileQueuedForImport[] = [];

    for (ii = 0; ii < this.profileData.length; ii++) {
      try {
        this.profileData[ii].companyName = this.profileData[ii].companyName.trim();
        this.profileData[ii].firstName = this.profileData[ii].firstName.trim();
        this.profileData[ii].lastName = this.profileData[ii].lastName.trim();
        this.profileData[ii].parkerPayType = this.profileData[ii].parkerPayType.trimEnd();
        this.profileData[ii].deliveryType = this.profileData[ii].deliveryType.trimEnd();

        dataToValidate.push(this.profileData[ii]);
      } catch (err) {
        rowError = true;
      }
    }

    return dataToValidate;
  }

  ClearParkerProfiles(): void {
    this.profileData = [];
    this.validationErrors = [];
    this.parkerSuccessResults = [];
    this.validationCheckCompleted = false;
    this.importErrorsExist = false;

    this.gridProfile.cdr.detectChanges();

    this.commit();
  }

  SaveParkerProfiles(): void {
    let rowError: boolean = false;
    let parkerImportList: IParkerProfileQueuedForImport[] = [];
    let ii: number = 0;

    this.importInProgress = true;

    this.showImportingDialog();

    while (false == rowError) {
      try {
        let aProfile: IParkerProfileQueuedForImport = {} as IParkerProfileQueuedForImport;

        aProfile = this.gridProfile.getRowByIndex(ii).data;

        aProfile.companyName = aProfile.companyName.trimEnd();
        aProfile.firstName = aProfile.firstName.trim();
        aProfile.lastName = aProfile.lastName.trim();
        aProfile.parkerPayType = aProfile.parkerPayType.trimEnd();
        aProfile.deliveryType = aProfile.deliveryType.trimEnd();

        aProfile = this.EvalAndFixUndefinedMembers(aProfile);
        parkerImportList.push(aProfile);

        ii++;
      } catch (err) {
        rowError = true;
      }
    }

    let ParkerPrep = new ParkerImportPrep(this.companyList);

    let parkersReadyForParkerTable: IParkerProfileForParkerTable[] = ParkerPrep.CreateParkerImportListForParkerTable(
      parkerImportList,
      this.currentLotNumber,
      this._appGeneralState.userName,
    );

    this.importErrorsExist = false;

    this.PostParkerImportData(parkersReadyForParkerTable);
  }

  EvalAndFixUndefinedMembers(aProfile: IParkerProfileQueuedForImport): IParkerProfileQueuedForImport {
    if (aProfile.cardNumber == undefined) aProfile.cardNumber = '0';

    if (aProfile.stallNumber == undefined) aProfile.stallNumber = '';

    if (aProfile.billingAddress == undefined) aProfile.billingAddress = '';

    if (aProfile.suiteNumber == undefined) aProfile.suiteNumber = '';

    if (aProfile.city == undefined) aProfile.city = '';

    if (aProfile.state == undefined) aProfile.state = '';

    if (aProfile.zip == undefined) aProfile.zip = '';

    if (aProfile.phoneNumber == undefined) aProfile.phoneNumber = '';

    if (aProfile.emailAddress == undefined) aProfile.emailAddress = '';

    if (aProfile.vehicleLicense == undefined) aProfile.vehicleLicense = '';

    if (aProfile.vehicleMake == undefined) aProfile.vehicleMake = '';

    if (aProfile.vehicleModel == undefined) aProfile.vehicleModel = '';

    if (aProfile.vehicleColor == undefined) aProfile.vehicleColor = '';

    if (aProfile.vehicleState == undefined) aProfile.vehicleState = '';

    if (aProfile.comments == undefined) aProfile.comments = '';

    if (aProfile.endDate == undefined) aProfile.endDate = null;

    return aProfile;
  }

  onRouteToParkersHome(): void {
    this.router.navigate([`/parkerv2`]);
  }

  PostParkerImportData(parkerImportData: IParkerProfileForParkerTable[]): void {
    let parkerImportResults: IParkerProfileImportResult[];
    this.dataService.PostParkerImport(parkerImportData).subscribe(
      (res) => {
        parkerImportResults = res;
      },
      (err: any) => {
        this.closeImportDialog();

        let action: any;
        this.snackBar.open(
          'An unexpected error occurred.  Please try again and if this continues please contact your system administrator',
          action,
          {
            duration: 7000,
          },
        );
        this.validationErrors = [];
        this.profileValidationCompleted = false;
        this.importInProgress = false;
      },
      () => {
        this.validationErrors = [];
        this.profileValidationCompleted = false;
        this.parkerImportResults = parkerImportResults;
        this.PostProcessImportData();
      },
    );
  }

  PostProcessImportData(): void {
    let ii: number = 0;
    let errorsExist: boolean = false;
    let statusString: string = '';
    this.importErrorsExist = false;

    for (ii = 0; ii < this.parkerImportResults.length; ii++) {
      if (this.parkerImportResults[ii].result == true) {
        this.parkerSuccessResults.push(this.parkerImportResults[ii]);
        this.gridProfile.deleteRow(this.parkerImportResults[ii].rowNumber);
      } else {
        errorsExist = true;
        this.importErrorsExist = true;
      }
    }

    if (errorsExist) {
      statusString =
        'Not all parkers were imported successfully.  Please review the list above to see the Parkers that failed.  Please edit and try again. If this continues please contact your system administrator';
    } else {
      statusString =
        this.parkerImportResults.length + ' Parker Profile(s) were imported successfully without any errors.';
    }

    let action: any;
    this.snackBar.open(statusString, action, {
      duration: 7000,
    });

    this.commit();

    this.importInProgress = false;

    this.closeImportDialog();
  }

  GetAllCompanyMarketRatesForLotNumber(lotNumber: string): void {
    this.dataService.getAllActiveMarketCompanyRatesByLotNumberWithCompanyId(lotNumber).subscribe(
      (res) => {
        this.marketCompanyRatesForLotNumber = res;
      },
      (err: any) => {},
      () => {},
    );
  }

  onValidateParkerProfiles(): void {
    this.isValidating = true;
    try {
      let statusString: string = '';
      this.validationErrors = []; //reset from a previous run
      let dataToValidate: IParkerProfileQueuedForImport[] = this.GetProfileDataForValidation();
      this.numberOfParkersValidated = this.profileData.length;
      let errorValidator = new ParkerImportValidation(
        dataToValidate,
        this.companyList,
        this.marketCompanyRatesForLotNumber,
      );

      this.validationErrors = errorValidator.ValidateParkerProfiles(dataToValidate);
      this.profileValidationCompleted = true;
      //Marked for Deletion :: 20241029 :: Ken Moss
      // this.SetValidationStatus();
      this.gridProfile.cdr.detectChanges();
      this.validationCheckCompleted = true;
      this.isValidating = false;

      if (this.validationErrors.length == 0) {
        statusString = 'No validation errors exist.  The Parker Profiles are ready to submit.';
      } else {
        statusString = 'Validation errors exist.  Please review below and correct before submitting.';
      }

      this.gridProfile.markForCheck();

      let action: any;
      this.snackBar.open(statusString, action, {
        duration: 4000,
      });
    } catch (err) {
      console.error('error during validation: ' + err);
      this.isValidating = false;
    }
  }

  // StartValidationParkerProcess(): void {
  //   try {
  //     let statusString: string = '';
  //     this.validationErrors = [];
  //     let dataToValidate: IParkerProfileQueuedForImport[] = this.GetProfileDataForValidation();
  //     let errorValidator = new ParkerImportValidation(
  //       dataToValidate,
  //       this.companyList,
  //       this.marketCompanyRatesForLotNumber,
  //     );

  //     this.validationErrors = errorValidator.ValidateParkerProfiles(dataToValidate);
  //     this.profileValidationCompleted = true;
  //     this.SetValidationStatus();
  //     this.gridProfile.cdr.detectChanges();
  //     this.validationCheckCompleted = true;

  //     this.isValidating = false;

  //     if (this.validationErrors.length == 0) {
  //       statusString = 'No validation errors exist.  The Parker Profiles are ready to submit.';
  //     } else {
  //       statusString = 'Validation errors exist.  Please review below and correct before submitting.';
  //     }

  //     let action: any;
  //     this.snackBar.open(statusString, action, {
  //       duration: 4000,
  //     });
  //   } catch (err) {
  //     console.error('error during validation: ' + err);
  //     this.isValidating = false;
  //   }
  // }

  SetValidationStatus(): void {
    let ii: number = 0;
    let rowError: boolean = false;

    while (false == rowError) {
      try {
        let errorsExist = this.ErrorStatusByRowNumber(ii);

        let statusCode: number;
        let aProfile: IParkerProfileQueuedForImport = this.gridProfile.getRowByIndex(ii).data;

        if (errorsExist) {
          statusCode = 2; //errors exist post validation
        } else statusCode = 1;

        this.gridProfile.updateCell(statusCode, aProfile.rowNumber, 'status');

        ii++;
      } catch (err) {
        rowError = true;
      }
    }
  }

  ErrorStatusByRowNumber(rowNumber: number): boolean {
    let errorExist: boolean = false;
    let ii: number;

    if (this.validationErrors.length == 0) return false;

    for (ii = 0; ii < this.validationErrors.length; ii++) {
      if (this.validationErrors[ii].rowNumber == rowNumber) {
        errorExist = true;
        break;
      }
    }

    return errorExist;
  }

  isError(rowNumber: number, columnName: string): boolean {
    let ii: number;
    let errorStatus: boolean = false;

    if (this.suppressErrors) return false;

    for (ii = 0; ii < this.validationErrors.length; ii++) {
      if (this.validationErrors[ii].rowNumber == rowNumber && this.validationErrors[ii].columnName == columnName) {
        errorStatus = true;
        break;
      }
    }

    return errorStatus;
  }

  RowEditFinished(event: any): void {
    let ii: number = 0;
    let rowError: boolean = false;
    let currentMaxRowNumber = -1;

    while (false == rowError) {
      try {
        let aProfile: IParkerProfileQueuedForImport = this.gridProfile.getRowByIndex(ii).data;

        if (aProfile.rowNumber > currentMaxRowNumber) currentMaxRowNumber = aProfile.rowNumber;

        //aProfile  = this.gridProfile.getRowByIndex(ii).data;

        if (aProfile.rowNumber == -1) {
          this.gridProfile.updateCell(currentMaxRowNumber + 1, -1, 'rowNumber');
          this.commit();
        }

        ii++;
      } catch (err) {
        rowError = true;
      }
    }

    this.gridProfile.cdr.detectChanges();
    this.commit();
  }

  ValidationErrorToolTip(rowNumber: number, columnName: string): string {
    let ii: number;
    let errorMessage: string = '';

    for (ii = 0; ii < this.validationErrors.length; ii++) {
      if (this.validationErrors[ii].rowNumber == rowNumber && this.validationErrors[ii].columnName == columnName) {
        errorMessage = this.validationErrors[ii].message;
        break;
      }
    }

    return errorMessage;
  }

  refreshGrid(): void {
    this.gridProfile.cdr.detectChanges();
  }

  GetRateListForCompany(companyName: string): void {
    let companyId: string = '';
    let ii: number;

    for (ii = 0; ii < this.companyList.length; ii++) {
      if (companyName.toLocaleUpperCase() === this.companyList[ii].companyName.toLocaleUpperCase())
        companyId = this.companyList[ii].companyId;
    }

    if (companyId != '') {
      this.getCompanyAndMarketRateListByLotNumber(this.currentLotNumber, companyId);
    }
  }

  getCompanyAndMarketRateListByLotNumber(lotNumber: string, companyId: string) {
    this.dataService.getMarketCompanyRatesForLotAndCompany(lotNumber, companyId).subscribe(
      (res) => {
        this.marketRateList = res;
      },
      (err: any) => {},
      () => {},
    );
  }

  initStateList(): void {
    let stateList = new AceStates();

    this.stateList = stateList.AceUSStateList();
  }

  setFilter(filterId: any): void {
    if (filterId == '0') {
      this.filteredData = this.profileData;
      return;
    }

    this.setFilteredData(filterId);
  }

  setFilteredData(typeFilter: string) {
    let ii: number;
    this.filteredData = [];

    if (typeFilter == '1') {
      for (ii = 0; this.gridProfile.data.length; ii++) {
        if (ii != 2) this.filteredData.push(this.profileData[ii]);
      }
    }

    if (typeFilter == '2') {
      for (ii = 0; this.gridProfile.data.length; ii++) {
        if (ii == 2) this.filteredData.push(this.profileData[ii]);
      }
    }

    this.gridProfile.data = null;
  }

  SetIndex(): void {
    this.currentRowIndex++;
  }

  GetStyles(): any {
    this.currentRowIndex++;
    let borderStyles: any;
    if (this.currentRowIndex == 2) {
      borderStyles = {
        border: 'solid',
      };
    } else borderStyles = '';

    return borderStyles;
  }

  public borderStyles = {
    border: 'solid',
  };

  ToggleValidation(): void {
    this.validationMode = !this.validationMode;
  }

  IsError(rowNumber: number): boolean {
    if (rowNumber == 2) return true;
    else return false;
  }

  GetRateListByCompany(companyName: any): void {
    this.rateList = [100, 101];
    let ii: number;

    for (ii = 0; ii < this.companyRateList.length; ii++) {
      if (companyName.toUpperCase() == this.companyRateList[ii].companyName.toUpperCase())
        this.rateList.push(this.companyRateList[ii].rateNumber);
    }
  }

  RowDeleteFinished(): void {
    this.commit();
  }

  public dataPasted(processedData: any) {
    this.currentRowIndex = 0;

    this.validationCheckCompleted = false;

    this.numberOfParkers = processedData.length;

    this.addRecords(processedData);
  }

  public addRecords(processedData: any[]) {
    this.enablePasteMode = true;
    this.gridProfile.cdr.detectChanges();
    const columns = this.gridProfile.visibleColumns;

    const pk = this.gridProfile.primaryKey;
    for (const curentDataRow of processedData) {
      const rowData: any = {};
      for (const col of columns) {
        rowData[col.field] = curentDataRow[col.visibleIndex];
      }
      // generate PK
      rowData[pk] =
        this.gridProfile.data!.length + this.gridProfile.transactions.getAggregatedChanges(false).length + 1;
      this.gridProfile.addRow(rowData);
    }

    // scroll to last added row
    this.gridProfile.verticalScrollContainer.dataChanged.pipe(first()).subscribe(() => {
      this.gridProfile.verticalScrollContainer.scrollTo(this.gridProfile.dataView.length - 1);
    });

    this.enablePasteMode = false;
    this.commit();
    this.gridProfile.cdr.detectChanges();
  }

  //   public updateRecords(processedData: any[]) {
  //       const cell = this.gridProfile.selectedCells[0];
  //       const pk = this.gridProfile.primaryKey;
  //       if (!cell) {
  //           return;
  //       }
  //       const rowIndex = cell.row.index;
  //       // const rowPkValue = cell.row.key;
  //       const cellIndex = cell.column.visibleIndex;
  //       const columns = this.gridProfile.visibleColumns;
  //       let index = 0;
  //       const updatedRecsPK = [];
  //       for (const curentDataRow of processedData) {
  //           const rowData: any = {};
  //           const dataRec = this.gridProfile.data![rowIndex + index];
  //           const rowPkValue = dataRec
  //               ? dataRec[pk]
  //               : this.gridProfile.data!.length + 1;
  //           rowData[pk] = rowPkValue;
  //           for (let j = 0; j < columns.length; j++) {
  //               let currentCell;
  //               if (j >= cellIndex) {
  //                   currentCell = curentDataRow.shift();
  //               }
  //               const colKey = columns[j].field;
  //               rowData[colKey] =
  //                   currentCell || (!!dataRec ? dataRec[colKey] : null);
  //           }
  //           if (!dataRec) {
  //               // no rec to update, add instead
  //               rowData[pk] = rowPkValue;
  //               this.gridProfile.addRow(rowData);

  //               continue;
  //           }
  //           this.gridProfile.updateRow(rowData, rowPkValue);
  //           this.gridProfile.cdr.detectChanges();
  //           updatedRecsPK.push(rowPkValue);
  //           index++;
  //       }
  //   }

  public undo() {
    this.gridProfile.transactions.undo();
  }

  public redo() {
    // this.gridProfile.transactions.redo();
    // if (this.pasteMode === 'Paste starting from active cell') {
    //     return;
    // }
    // this.gridProfile.verticalScrollContainer.dataChanged
    //     .pipe(first())
    //     .subscribe(() => {
    //         this.gridProfile.verticalScrollContainer.scrollTo(
    //             this.gridProfile.dataView.length - 1
    //         );
    //     });
  }

  commit() {
    this.gridProfile.transactions.commit(this.profileData);
  }

  undoEnabled(): boolean {
    return this.gridProfile.transactions.canUndo;
  }

  redoEnabled(): boolean {
    return this.gridProfile.transactions.canRedo;
  }

  hasTransactions(): boolean {
    return this.gridProfile.transactions.getAggregatedChanges(false).length > 0;
  }

  showImportingDialog(): void {
    const dlgTitle: string = 'Importing Parker Profiles';
    const dlgLine1: string = 'Stand by while we import new Parker Profiles.';
    const dlgLine2: string = `This may take a minute or two depending upon the number of profiles.`;
    let spaceUserId: number;

    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';

    const dialogRef = this._matDialog.open(GenericProcessingComponent, {
      data: { title: dlgTitle, line1: dlgLine1, line2: dlgLine2, button: '' },
      width: '450px',
      enterAnimationDuration,
      exitAnimationDuration,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
      }
    });
  }

  closeImportDialog(): void {
    this._matDialog.closeAll();
  }

  //20240810 :: Ken Moss - Added to retrieve company list during startup instead of from company state service
  GetActiveAndInActiveCompanyListForLotNumber(lotNumber: string) {
    let queryCompanyList: ICompanySearchCriteria[];

    this.dataService.GetCompanyListActiveAndInActiveForLotNumber(lotNumber).subscribe(
      (companyList) => {
        queryCompanyList = companyList;
      },
      (err: any) => {},
      () => {
        //This query returns all companies.  Filter down to active companies only
        this.companyList = queryCompanyList.filter((active) => active.active == 'A');
        this.GetAllCompanyMarketRatesForLotNumber(this.currentLotNumber);
      },
    );
  }

  showErrorDialog(errorRowNumber: number): void {
    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';
    let importReportError: IImportDialogErrors = {} as IImportDialogErrors;
    errorRowNumber = errorRowNumber - 1;

    let findMatch: boolean = this.validationErrors.some((arr) => arr.rowNumber == errorRowNumber);

    if (findMatch) {
      this._appGeneralState.importValidationErrors = this.validationErrors;

      importReportError.errorList = this.validationErrors;
      importReportError.errorRowNumber = errorRowNumber;

      const dialogRef = this._matDialog.open(DialogParkerImportErrorsComponent, {
        data: { errorRowNumber: errorRowNumber },
        width: '450px',
        minHeight: '450px',
        enterAnimationDuration,
        exitAnimationDuration,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == true) {
        }
      });
    }
  }
}
